"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AssetGlobals {
}
//TODO add assets here
AssetGlobals.BG_IMAGE = 'bg_scene_00';
AssetGlobals.Knob = 'knob.png';
AssetGlobals.BG_IMAGE_LOADING = 'bg_scene_01';
AssetGlobals.BG_IMAGE_WHITE = 'bg_white';
AssetGlobals.BG_ROAD = 'bg_road';
AssetGlobals.BG_IMAGE_MENU = 'bg_backmirror';
AssetGlobals.BTN_BG = 'btn_bg';
AssetGlobals.BG_IMAGE_MAIN_CAM = 'bg_backmirror_small';
AssetGlobals.SPRITE_STEERING = 'sprite_steering';
AssetGlobals.SPRITE_CACTUS = 'sprite_cactus';
AssetGlobals.STREET_LAMP = 'street_lamp';
exports.AssetGlobals = AssetGlobals;
